/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeRoles.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Roles Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const ROLE_LIST_CONTAINER_LOADED = 'ROLE_LIST_CONTAINER_LOADED';
export const ROLE_LIST_CONTAINER_UNLOADED = 'ROLE_LIST_CONTAINER_UNLOADED';
export const ROLE_LIST_TABLE_LOADED = 'ROLE_LIST_TABLE_LOADED';
export const ROLE_LIST_TABLE_UNLOADED = 'ROLE_LIST_TABLE_UNLOADED';
export const ROLE_SELECT_ROW = 'ROLE_SELECT_ROW';
export const ROLE_ADD = 'ROLE_ADD';
export const ROLE_EDIT = 'ROLE_EDIT';
export const ROLE_DELETE = 'ROLE_DELETE';
export const ROLE_OPEN_WARNING = 'ROLE_OPEN_WARNING';
export const ROLE_CLOSE_WARNING = 'ROLE_CLOSE_WARNING';

export const ROLE_EDIT_CONTAINER_LOADED = 'ROLE_EDIT_CONTAINER_LOADED';
export const ROLE_EDIT_CONTAINER_UNLOADED = 'ROLE_EDIT_CONTAINER_UNLOADED';
export const ROLE_EDIT_FORM_LOADED = 'ROLE_EDIT_FORM_LOADED';
export const ROLE_EDIT_FORM_UNLOADED = 'ROLE_EDIT_FORM_UNLOADED';
export const ROLE_EDIT_DATA_LOAD = 'ROLE_EDIT_DATA_LOAD';
export const ROLE_SET_TREE = 'ROLE_SET_TREE';
export const ROLE_LOAD_PERMISSIONS = 'ROLE_LOAD_PERMISSIONS';
export const ROLE_EDIT_UPDATE_CHECKED = 'ROLE_EDIT_UPDATE_CHECKED';
export const ROLE_EDIT_UPDATE_EXPANDED = 'ROLE_EDIT_UPDATE_EXPANDED';
export const ROLE_EDIT_CONTAINER_SUBMIT = 'ROLE_EDIT_CONTAINER_SUBMIT';
export const ROLE_EDIT_RESET_TREE = 'ROLE_EDIT_RESET_TREE';
export const ROLE_EDIT_CONTAINER_CANCEL = 'ROLE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeRoles.js